import "./preLoader.css"

const Preloader = () => {
  return <div id="preloader">
    <div className="loader"></div>
  </div>
}

export default Preloader
